$(document).on("click", '.cat-accordion-header:not(.cat-link)', function() {
    var parent = $(this).closest(".cat-accordion-item");
    parent.siblings().removeClass("active");
    parent.toggleClass("active");
});